import { Select } from 'antd'
import React, { useState } from 'react'

export default function MultiSelectOpen({options, value, onChangeFunc }) {
    const [domainNameSelected, setDomainNameSelected] = React.useState([])
    const handleChange = (value) => {
        let newVal = value.map((obj, ind) => {
            return { value: obj, label: obj }
        })
        onChangeFunc(newVal)
        setDomainNameSelected(newVal)
    };
    return (
        <>
            <Select
                size='large'
                mode="multiple"
                allowClear
                options={options}
                style={{ width: '45%',}}
                placeholder="Select Domains"
                onChange={handleChange}
                value={value}
                optionLabelProp="label"
                filterOption={(input, option) =>
                    option?.label.toLowerCase().includes(input.toLowerCase())
                }
                maxTagCount={0}  // Hide the tags
            maxTagPlaceholder={`${value.length} selected`}  // Custom placeholder
            />
        </>
    )
}
